import Drawable from '../entities/Drawable.js';
import Sprite from './Sprite.js';
import PixelText from './PixelText.js';
import TypeBadge from './TypeBadge.js';

import { spriteStore } from '../images.js';

export default class AddedToPokedexSummary extends Drawable {
    constructor({ pokemon }) {
        super();
        this.visible = false;
        this.pokemon = pokemon;

        this.backgroundSprite = spriteStore.store.addedToPokedexSummaryBackgroundSprite;
        this.nameAndNumberText = new PixelText({
            text: `No. ${this.pokemon.id}\t${this.pokemon.name}`,
            position: { x: 16, y: 27 },
            color: 'black',
        });

        this.pokemonSprite = new Sprite({
            moving: false,
            position: { x: 152, y: 24 },
            frames: { val: 0, max: 1 },
            isFromSpriteSheet: true,
            spriteSheetCols: 20,
            spriteSheetRows: 20,
            spriteIndex: this.pokemon.id - 1,
            visible: true,
        });
        this.typeBadge1 = new TypeBadge({
            type: this.pokemon.type1,
            position: { x: 16, y: 44 },
            visible: true,
        });
        this.typeBadge2 =
            !!this.pokemon.type2 && this.pokemon.type1 !== this.pokemon.type2
                ? new TypeBadge({
                      type: this.pokemon.type2,
                      position: { x: 16 + 34, y: 44 },
                      visible: true,
                  })
                : null;
        this.pokedexEntryText = new PixelText({
            text: 'This is where the pokedex entry would be... if I had one...',
            position: { x: 12, y: 99 },
            maxWidth: 216,
            color: 'black',
        });
    }

    draw() {
        if (!this.visible) {
            return;
        }
        if (!!this.pokemon && !this.pokemonSprite.image) {
            this.pokemonSprite.setImage(this.pokemon.frontSprite.image);
        }

        this.backgroundSprite.draw();
        this.nameAndNumberText.draw();
        this.typeBadge1.draw();
        if (this.typeBadge2) {
            this.typeBadge2.draw();
        }
        this.pokedexEntryText.draw();
        this.pokemonSprite.draw();
    }
}
